class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.initEventListeners();
    this.wrapper = this.querySelector('.nav-dropdown__wrapper');
    let isMouseOutside = false;
    this.desktopTriggers = document.querySelectorAll('.js-primary-link');
    this.closeButtons = this.querySelectorAll('[data-close]');

    this.wrapper.addEventListener('mouseout', (event) => {
      if (!this.wrapper.contains(event.relatedTarget)) {
        isMouseOutside = true;
      }
    });

    this.wrapper.addEventListener('mouseover', () => {
      isMouseOutside = false;
    });

    this.addEventListener('click', () => {
      if (isMouseOutside) {
        this.classList.add('blur');
        this.classList.remove('visible');

        setTimeout(() => {
          this.classList.remove('blur');
        }, 1000);
      };
    });

    const handleEvent = () => {
      this.setHeightVariables();
    };

    ['load', 'resize', 'scroll'].forEach(event =>
      window.addEventListener(event, handleEvent)
    );

    this.desktopTriggers.forEach(desktopTrigger => {
      const linkLi = desktopTrigger.closest('li');
      const linkDropdown = linkLi.querySelector('mega-menu');
      linkDropdown.classList.remove('visible');

      linkLi.addEventListener('mouseover', () => {
        linkDropdown.classList.add('visible');
      });

      linkLi.addEventListener('mouseout', () => {
        linkDropdown.classList.remove('visible');
      });
    });

    this.closeButtons.forEach(closeButton => {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();

        closeButton.closest('mega-menu').classList.remove('visible');
      });
    });
  }

  initEventListeners() {
    const menuItems = this.querySelectorAll('.nav-dropdown__list a');
    const contentSections = this.querySelectorAll('.nav-dropdown__secondary');

    menuItems.forEach(item => {
      item.addEventListener('mouseover', (event) => {
        event.preventDefault();

        const targetTab = item.getAttribute('data-target');

        // Remove active class from all items and sections
        this.resetActiveClasses(menuItems, contentSections);

        // Add active class to hovered item and corresponding section
        item.classList.add('active');
        const targetSection = this.querySelector(`.nav-dropdown__secondary[data-tab="${targetTab}"]`);
        if (targetSection) {
          targetSection.classList.add('active');
        }
      });
    });
  }

  setHeightVariables() {
    const headerDesktopElement = document.querySelector('sticky-header');
    const widgetDesktop = document.querySelector('.widget-menu--desktop');

    document.documentElement.style.setProperty(
      '--header-desktop-height',
      `${Math.floor(headerDesktopElement.getBoundingClientRect().bottom)}px`
    );

    if (widgetDesktop) {
      const widgetHeight = widgetDesktop.offsetHeight;

      document.documentElement.style.setProperty(
        '--widget-height',
        `${widgetHeight}px`
      );
    };
  }

  resetActiveClasses(items, sections) {
    items.forEach(item => item.classList.remove('active'));
    sections.forEach(section => section.classList.remove('active'));
  }
}

// Define the custom element
customElements.define('mega-menu', MegaMenu);
